import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import AreaList from "../../../../components/cases/assets/balanceOfAssets/realEstate/AreaList";
import Summary from "../../../../components/cases/assets/balanceOfAssets/realEstate/Summary";
import { Box } from "@mui/system";
import {
  getRSCategoryList,
  getAllRSUsers,
} from "../../../../services/yourAssets/RealEstateServices";
import { Circles } from "react-loader-spinner";
import { useParams } from "react-router-dom";
const RealEstate = ({ next, tabText }) => {
  const { id } = useParams();
  const currentCard = useSelector((state) => state.currentCard.currentCard);
  const [propertyTypes, setPropertyTypes] = useState([]);
  const [allrsUsers, setAllrsUsers] = useState([]);
  const [selectedProperties, setSelectedProperties] = useState([]);
  const [userProperties, setUserProperties] = useState([]);
  const [continueButton, setContinueButton] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  //////   API
  const getCategories = async () => {
    let apiResult = await getRSCategoryList();

    if (apiResult?.success) {
      let array = [];
      for (let i = 0; i < apiResult?.payLoad.length; i++) {
        const elementI = apiResult?.payLoad[i];
        let obj = {
          id: elementI.realEstateCategoryId,
          name: elementI.name,
          key: elementI.name,
          count: 0,
          data: [],
        };

        array.push(obj);
      }
      setPropertyTypes(array);
    }
  };
  const getAllRSUsersData = async () => {
    let apiResult = await getAllRSUsers(id);

    if (apiResult?.success) {
      let array = [];
      for (let i = 0; i < apiResult?.payLoad.length; i++) {
        const elementI = apiResult?.payLoad[i];

        array.push(elementI);
        setContinueButton(false);
      }

      setAllrsUsers(array);
    }
  };

  const updatePropertyCountInitial = () => {
    const updatedPropertTypes = [...propertyTypes];
    allrsUsers.forEach((el) => {
      const propertyTypeIndex = updatedPropertTypes.findIndex(
        (item) => item.name === el.realEstateCategoryName
      );
      let currentCount = updatedPropertTypes[propertyTypeIndex]?.count ?? 0;

      currentCount += 1;
      updatedPropertTypes[propertyTypeIndex]["count"] = currentCount;
    });

    setPropertyTypes(updatedPropertTypes);

    if (allrsUsers?.length > 0) {
      const newSelectedProperties = updatedPropertTypes.filter(
        (el) => el.count > 0
      );
      setSelectedProperties(newSelectedProperties);
    }
  };

  const makePropertyData = () => {
    let SelectedPropertiesData = [];
    selectedProperties.forEach((property, propertyIndex) => {
      let propertyData = [];

      let ifAlreadyExists = allrsUsers.some(
        (el) => el.realEstateCategoryName === property.name
      );
      if (ifAlreadyExists) {
        const sameTypeProperties = allrsUsers.filter(
          (el) => el.realEstateCategoryName === property.name
        );
        for (let i = 0; i < property?.count; i++) {
          if (i < sameTypeProperties.length) {
            let subOwnerData = [];
            let mainOwner = sameTypeProperties[i].RealEstate;
            //setting up property status
            let propertyStatus = [];
            if (mainOwner.isLiving) {
              propertyStatus.push({
                value: "My Self",
                label: "My Self",
                id: 1,
              });
            }
            if (mainOwner.isKidsLiving) {
              propertyStatus.push({ value: "Kids", label: "Kids", id: 2 });
            }
            if (mainOwner.isRenting) {
              propertyStatus.push({
                value: "Renting",
                label: "Renting",
                id: 3,
              });
            }

            /////// making main object
            let mainOwnerObj = {};
            mainOwnerObj = {
              realEstateCategoryId: mainOwner.realEstateCategoryId,
              realEstateId: mainOwner.realEstateId,
              date: mainOwner.dateOfValue,
              nameOfOwners: mainOwner.nameOfOwner,
              ownership: mainOwner.ownerShipPercentage,
              valueOfTheProperty: mainOwner.valueOfProperty,
              areaLT200ms: mainOwner.isArea200,
              propertyType: [...propertyStatus],
            };
            subOwnerData.push(mainOwnerObj);
            sameTypeProperties[i].RealEstate.subRealEstates.forEach((el) => {
              let subOwnerObj = {};
              subOwnerObj = {
                date: el.dateOfValue,
                nameOfOwners: el.nameOfOwner,
                ownership: el.ownerShipPercentage,
                valueOfTheProperty: el.valueOfProperty,
                subRealEstateId: el.subRealEstateId || "",
                realEstateId: el.realEstateId || "",
              };
              subOwnerData.push(subOwnerObj);
            });

            let obj = {
              name: `${sameTypeProperties[i]?.realEstateCategoryName} ${i + 1}`,
              key: `${i + 1}`,
              sharesData: [...subOwnerData],
            };

            propertyData.push(obj);
          } else {
            const obj = {
              name: `${sameTypeProperties[0]?.realEstateCategoryName} ${i + 1}`,
              key: `${i + 1}`,
              sharesData: [],
            };

            propertyData.push(obj);
          }
        }
      } else {
        for (let i = 0; i < property.count; i++) {
          const obj = {
            name: `${property.name} ${i + 1}`,
            key: `${i + 1}`,
            sharesData: [],
          };
          propertyData.push(obj);
        }
      }
      let propertyTypeObj = {
        id: property.id,
        name: property.name,
        key: property.name,
        count: property.count,
        data: [...propertyData],
      };
      SelectedPropertiesData.push(propertyTypeObj);
    });
    setUserProperties(SelectedPropertiesData);
  };

  useEffect(() => {
    const initialMountEffect = async () => {
      setIsLoading(true);
      await getCategories();
      await getAllRSUsersData();
      setIsLoading(false);
    };
    initialMountEffect();
  }, []);
  useEffect(() => {
    if (allrsUsers.length > 0 && propertyTypes.length > 0) {
      updatePropertyCountInitial();
    }
  }, [allrsUsers]);

  const handleContinueButton = () => {
    setContinueButton(true);
  };

  const renderTab = () => {
    if (currentCard === 1)
      return (
        <>
          <AreaList
            key={1}
            setSelectedProperties={setSelectedProperties}
            selectedProperties={selectedProperties}
            propertyTypes={propertyTypes}
            setPropertyTypes={setPropertyTypes}
            continueBtnChange={handleContinueButton}
          />
        </>
      );
    else if (currentCard === 2)
      return (
        <>
          <Summary
            key={2}
            setSelectedProperties={setUserProperties}
            selectedProperties={userProperties}
            next={next}
            makePropertyData={makePropertyData}
            disableContinueButton={continueButton}
          />
        </>
      );
  };

  return (
    <>
      {isLoading ? (
        <Box
          className="real-estate-container"
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Circles color="#dfc8db" height={80} width={80} />
        </Box>
      ) : (
        renderTab()
      )}

      {/* <SuggestionBox
        mainText={tabText}
        tabName="RealEstate"
        setVisited={visited}
      /> */}
    </>
  );
};

export default RealEstate;
